import { render } from "./VSvg.vue?vue&type=template&id=706f5d5d"
import script from "./VSvg.vue?vue&type=script&lang=js"
export * from "./VSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__